import React from "react";
import Header from "../menu/Header";
import Menu from "../menu/Menu";
import { useEffect, useState } from "react";
import { getAllRequest } from "../../../services/kojaServices";
import { Tooltip } from "react-tooltip";
import { serverApi } from "../../../confing/confing";

const Requests = () => {
  const moment = require("moment-jalaali");
  const [listRequests, setListRequest] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await getAllRequest();
        console.log(data);
        setListRequest(data.result);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="" style={{ paddingTop: "10px" }}>
      <Header />
      <div
        className="d-flex request-box-content"
        style={{ margin: "20px 30px 20px 30px" }}
      >
        <Menu />
        <div className="w-100 text-center ">
          <div className="requestes-box-tabel table-responsive">
            <table className="table  table-borderless">
              <thead>
                <tr style={{ color: "#fff" }}>
                  <th
                    scope="col"
                    style={{
                      borderLeft: "1px solid #fff",
                      borderBottom: "1px solid #fff",
                    }}
                  >
                    شماره صورت کارشناسی
                  </th>
                  <th
                    scope="col"
                    style={{
                      borderLeft: "1px solid #fff",
                      borderBottom: "1px solid #fff",
                    }}
                  >
                    آدرس صورت کارشناسی
                  </th>
                  <th
                    scope="col"
                    style={{
                      borderLeft: "1px solid #fff",
                      borderBottom: "1px solid #fff",
                    }}
                  >
                    نوع ملک
                  </th>
                  <th
                    scope="col"
                    style={{
                      borderLeft: "1px solid #fff",
                      borderBottom: "1px solid #fff",
                    }}
                  >
                    منطقه درخواستی
                  </th>
                  <th
                    scope="col"
                    style={{
                      borderLeft: "1px solid #fff",
                      borderBottom: "1px solid #fff",
                    }}
                  >
                    تاریخ ثبت درخواست
                  </th>
                  <th scope="col" style={{ borderBottom: "1px solid #fff" }}>
                    وضعیت
                  </th>
                </tr>
              </thead>
              <tbody>
                {listRequests.map((i, index) => (
                  <tr key={index} style={{ color: "#fff", paddingTop: "10px" }}>
                    <td style={{ borderLeft: "1px solid #fff" }}>
                      {i.requestToken}
                    </td>
                    <td
                      style={{ borderLeft: "1px solid #fff" }}
                      id={`my-anchor-element${index}`}
                    >
                      {i.address.substring(0, 20)}
                      <Tooltip
                        anchorSelect={`#my-anchor-element${index}`}
                        content={i.address}
                      />
                    </td>
                    <td style={{ borderLeft: "1px solid #fff" }}>
                      {i.Ex_Category.name}{" "}
                    </td>
                    <td style={{ borderLeft: "1px solid #fff" }}>
                      {i.Ex_Zone.name}
                    </td>
                    <td style={{ borderLeft: "1px solid #fff" }}>
                      {moment(i.createdAt, "YYYY-MM-DD").format(
                        "jYYYY/jMM/jDD"
                      )}
                    </td>
                    <td>
                      <div className="dropdown" key={index}>
                        <button
                          className="btn dropdown-toggle"
                          style={{ color: "#fff" }}
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          مشاهده
                        </button>
                        <ul
                          className="dropdown-menu text-end p-2"
                          style={{ width: "300px" }}
                        >
                          {i.expert.map((e, index) => (
                            <li key={index}>
                              {e.name}:
                              <span className="me-2">
                                {e.Ex_Expertors.status === "Pending" ? (
                                  "در انتظار ثبت"
                                ) : e.Ex_Expertors.status === "Reject" ? (
                                  "رد شده"
                                ) : e.Ex_Expertors.status === "Approved" ? (
                                  "در انتظار ارسال"
                                ) : e.Ex_Expertors.status === "Cancel" ? (
                                  "لغو شده"
                                ) : e.Ex_Expertors.status === "Finish" ? (
                                  <button>
                                    <a
                                      href={`https://api.koja-najafabad.ir/api/v1/file/user/sheet/${e.Ex_Expertors.ExSheetId}`}
                                      style={{color:"#000", textDecoration:"none"}}
                                      download
                                    >
                                      دانلود صورت کارشناسی
                                    </a>
                                  </button>
                                ) : e.Ex_Expertors.status === "WatingForPay" ? (
                                  "در انتظار ثبت"
                                ) : (
                                  ""
                                )}
                              </span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Requests;
